import { Link } from 'react-router-dom';
import { siteConfig, categories } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="relative overflow-hidden">
        <div className="absolute -left-20 -top-10 w-48 h-48 bg-background-50/5 rounded-full transform -rotate-12"></div>
        <div className="absolute -right-16 -bottom-8 w-40 h-40 bg-background-50/5 rounded-full transform rotate-12"></div>

        <div className="relative max-w-7xl mx-auto px-4 md:px-6 pt-14 pb-8">
          <div className="bg-secondary-600/40 rounded-2xl p-8 md:p-10 mb-8">
            <div className="flex flex-col lg:flex-row gap-10">
              <div className="lg:w-1/4">
                <Link to="/" className="flex items-center gap-2 mb-4">
                  <span className="w-9 h-9 rounded-full bg-background-50 flex items-center justify-center">
                    <i className="ri-eye-line text-secondary-500 text-lg"></i>
                  </span>
                  <span className="text-xl font-heading font-bold text-background-50">
                    {siteConfig.logoText}
                  </span>
                </Link>
                <p className="text-sm text-background-50/60 leading-relaxed">
                  {siteConfig.tagline}。实时追踪网红明星最新黑料，娱乐圈爆料、社会热点大瓜第一时间更新，吃瓜群众的必刷入口。
                </p>
              </div>

              <div className="lg:w-3/4 grid grid-cols-2 sm:grid-cols-3 gap-6">
                <div>
                  <h4 className="text-xs font-label uppercase tracking-wider text-background-50/50 mb-4">热门分类</h4>
                  <ul className="flex flex-col gap-2.5">
                    {categories.slice(0, 4).map((cat) => (
                      <li key={cat.slug}>
                        <Link
                          to={`/category/${cat.slug}`}
                          className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200"
                        >
                          {cat.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
                <div>
                  <h4 className="text-xs font-label uppercase tracking-wider text-background-50/50 mb-4">更多分类</h4>
                  <ul className="flex flex-col gap-2.5">
                    {categories.slice(4).map((cat) => (
                      <li key={cat.slug}>
                        <Link
                          to={`/category/${cat.slug}`}
                          className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200"
                        >
                          {cat.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
                <div>
                  <h4 className="text-xs font-label uppercase tracking-wider text-background-50/50 mb-4">关于我们</h4>
                  <ul className="flex flex-col gap-2.5">
                    <li>
                      <Link to="/about" className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200">
                        品牌介绍
                      </Link>
                    </li>
                    <li>
                      <Link to="/about" className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200">
                        联系我们
                      </Link>
                    </li>
                    <li>
                      <a href="#" className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200">
                        爆料投稿
                      </a>
                    </li>
                    <li>
                      <a href="#" className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200">
                        用户协议
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between pt-6 border-t border-background-50/10">
            <div className="flex flex-wrap items-center gap-3 text-xs text-background-50/50 mb-3 sm:mb-0">
              <span>&copy; {new Date().getFullYear()} {siteConfig.name} 版权所有</span>
              <span className="hidden sm:inline text-background-50/30">|</span>
              <a href="#" className="hover:text-background-50/80 transition-colors">用户协议</a>
              <span className="hidden sm:inline text-background-50/30">|</span>
              <a href="#" className="hover:text-background-50/80 transition-colors">隐私政策</a>
              <span className="hidden sm:inline text-background-50/30">|</span>
              <a href="#" className="hover:text-background-50/80 transition-colors" target="_blank" rel="nofollow noopener">京ICP备XXXXXXXX号</a>
            </div>
            <div className="flex items-center gap-4">
              <a href="#" className="w-8 h-8 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-background-50/20 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-background-50/20 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}